import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLine, FadeUp } from "./Reveal";
import { IMAGES } from "../config/site";

const MOMENTS = [
  { src: IMAGES.storyEnjoying, label: "Morning", note: "The first cup, before the world wakes up", cls: "md:col-span-7 aspect-[16/10]" },
  { src: IMAGES.experienceEvening, label: "Family", note: "Conversations that stretch past bedtime", cls: "md:col-span-5 aspect-[4/3.4]" },
  { src: IMAGES.friends, label: "Friends", note: "Refills that never need asking", cls: "md:col-span-5 aspect-[4/3.4]" },
  { src: IMAGES.eveningCup, label: "Evening", note: "The slow, well-earned pause", cls: "md:col-span-7 aspect-[16/10]" },
];

const ParallaxImg = ({ src, alt }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);
  return (
    <div ref={ref} className="h-full w-full overflow-hidden">
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        style={{ y }}
        className="h-[112%] w-full object-cover"
      />
    </div>
  );
};

const CoffeeExperience = () => (
  <section id="experience" data-testid="coffee-experience-section" className="bg-coffee py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <div className="mb-16 max-w-3xl">
        <FadeUp>
          <p className="mb-5 text-[11px] uppercase tracking-widest2 text-gold">Coffee Moments</p>
        </FadeUp>
        <h2 className="font-tamil text-3xl leading-[1.3] text-cream sm:text-5xl">
          <MaskLine delay={0.05}>ஒரு Cup Coffee...</MaskLine>
          <MaskLine delay={0.2} className="text-gold">
            ஒரு நாள் முழுக்க நினைவாக.
          </MaskLine>
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-12 md:gap-8">
        {MOMENTS.map((m, i) => (
          <FadeUp key={m.label} delay={i * 0.08} className={`${m.cls} group relative`}>
            <div className="h-full w-full overflow-hidden rounded-sm">
              <ParallaxImg src={m.src} alt={`${m.label} coffee moment`} />
            </div>
            <div className="pointer-events-none absolute inset-0 rounded-sm bg-gradient-to-t from-espresso/70 via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5">
              <p className="font-display text-xl italic text-cream">{m.label}</p>
              <p className="mt-1 text-xs text-cream/60">{m.note}</p>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);

export default CoffeeExperience;
